export interface StoryListing {
  id: string
  slug: string
  couple: string
  type: string
  place: string
  date: string
  coverImage: string
  excerpt: string
  to: string
}

export interface StoryFact {
  label: string
  value: string
  icon: string
}

export interface StoryTimelineStep {
  step: string
  time: string
  title: string
  desc: string
  icon: string
}

export interface StoryImage {
  id: string
  image: string
  title: string
  place: string
}

export interface StoryDetail extends StoryListing {
  facts: StoryFact[]
  paragraphs: string[]
  timeline: StoryTimelineStep[]
  images: StoryImage[]
  review: { quote: string; name: string; role: string }
}

export const weddingStories: StoryListing[] = [
  {
    id: 'st1',
    slug: 'aarthi-karthik',
    couple: 'Aarthi & Karthik',
    type: 'Temple Wedding',
    place: 'Madurai',
    date: '14 June 2024',
    coverImage:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20temple%20wedding%20mandapam%20with%20bride%20and%20groom%20in%20traditional%20attire%2C%20marigold%20and%20jasmine%20floral%20decor%2C%20warm%20golden%20light%2C%20cinematic%20editorial%20wedding%20photography%2C%20rich%20amber%20and%20gold%20tones&width=1600&height=1000&seq=shabi-story-aarthi-cover&orientation=landscape',
    excerpt:
      'A full-day South Indian temple wedding in Madurai, photographed from the morning muhurtham to the evening reception.',
    to: '/wedding-stories/aarthi-karthik',
  },
  {
    id: 'st2',
    slug: 'divya-suresh',
    couple: 'Divya & Suresh',
    type: 'Two-Day Celebration',
    place: 'Karaikudi',
    date: '22 August 2024',
    coverImage:
      'https://readdy.ai/api/search-image?query=Joyful%20South%20Indian%20Tamil%20bride%20and%20groom%20in%20traditional%20silk%20attire%20during%20a%20two%20day%20wedding%20celebration%20in%20Karaikudi%2C%20warm%20golden%20light%2C%20candid%20editorial%20wedding%20photography%2C%20rich%20amber%20tones%2C%20soft%20background&width=1600&height=1000&seq=shabi-story-divya-cover&orientation=landscape',
    excerpt:
      'A two-day Karaikudi celebration with a traditional home muhurtham, sangeet and a grand reception for 1,100 guests.',
    to: '/wedding-stories/divya-suresh',
  },
  {
    id: 'st3',
    slug: 'priya-vignesh',
    couple: 'Priya & Vignesh',
    type: 'Destination Wedding',
    place: 'Rameswaram',
    date: '9 February 2025',
    coverImage:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20couple%20at%20a%20beach%20destination%20wedding%20in%20Rameswaram%20at%20golden%20hour%2C%20traditional%20attire%2C%20cinematic%20editorial%20wedding%20photography%2C%20warm%20amber%20tones%2C%20wide%20composition&width=1600&height=1000&seq=shabi-story-priya-cover&orientation=landscape',
    excerpt:
      'A destination wedding by the sea in Rameswaram — temple rituals at dawn and a golden-hour beach reception.',
    to: '/wedding-stories/priya-vignesh',
  },
  {
    id: 'st4',
    slug: 'meera-arun',
    couple: 'Meera & Arun',
    type: 'Pre-Wedding & Muhurtham',
    place: 'Madurai',
    date: '3 November 2024',
    coverImage:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20couple%20in%20traditional%20attire%20in%20a%20lush%20green%20garden%20during%20a%20pre%20wedding%20shoot%2C%20warm%20sunset%20light%2C%20cinematic%20editorial%20photography%2C%20rich%20amber%20tones&width=1600&height=1000&seq=shabi-story-meera-cover&orientation=landscape',
    excerpt:
      'A romantic pre-wedding concept shoot in Madurai followed by an intimate family muhurtham the next morning.',
    to: '/wedding-stories/meera-arun',
  },
  {
    id: 'st5',
    slug: 'kavya-vishal',
    couple: 'Kavya & Vishal',
    type: 'Church Wedding & Reception',
    place: 'Trichy',
    date: '18 January 2025',
    coverImage:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20and%20groom%20at%20a%20church%20wedding%20in%20Trichy%20with%20warm%20evening%20light%2C%20elegant%20traditional%20attire%2C%20cinematic%20editorial%20wedding%20photography%2C%20rich%20amber%20and%20gold%20tones&width=1600&height=1000&seq=shabi-story-kavya-cover&orientation=landscape',
    excerpt:
      'An elegant Trichy church ceremony paired with a grand evening reception — two traditions, one beautiful day.',
    to: '/wedding-stories/kavya-vishal',
  },
  {
    id: 'st6',
    slug: 'lakshmi-hari',
    couple: 'Lakshmi & Hari',
    type: 'Traditional Muhurtham',
    place: 'Thanjavur',
    date: '27 May 2024',
    coverImage:
      'https://readdy.ai/api/search-image?query=Traditional%20South%20Indian%20Tamil%20muhurtham%20wedding%20in%20a%20Thanjavur%20temple%20mandapam%2C%20marigold%20decor%2C%20warm%20golden%20lighting%2C%20cinematic%20editorial%20wedding%20photography%2C%20rich%20amber%20tones&width=1600&height=1000&seq=shabi-story-lakshmi-cover&orientation=landscape',
    excerpt:
      'A timeless Thanjavur temple muhurtham rooted in ritual, captured with warmth, patience and detail.',
    to: '/wedding-stories/lakshmi-hari',
  },
]

export const weddingStoryDetails: StoryDetail[] = [
  {
    id: 'st2',
    slug: 'divya-suresh',
    couple: 'Divya & Suresh',
    type: 'Two-Day Celebration',
    place: 'Karaikudi',
    date: '22 August 2024',
    coverImage:
      'https://readdy.ai/api/search-image?query=Joyful%20South%20Indian%20Tamil%20bride%20and%20groom%20in%20traditional%20silk%20attire%20during%20a%20two%20day%20wedding%20celebration%20in%20Karaikudi%2C%20warm%20golden%20light%2C%20candid%20editorial%20wedding%20photography%2C%20rich%20amber%20tones%2C%20soft%20background&width=1600&height=1000&seq=shabi-story-divya-cover&orientation=landscape',
    excerpt:
      'A two-day Karaikudi celebration with a traditional home muhurtham, sangeet and a grand reception for 1,100 guests.',
    to: '/wedding-stories/divya-suresh',
    facts: [
      { label: 'Wedding Date', value: '22 August 2024', icon: 'ri-calendar-line' },
      { label: 'Venue', value: 'Meenakshi Kalyana Mandapam & family home, Karaikudi', icon: 'ri-map-pin-2-line' },
      { label: 'Guests', value: '1,100 guests across two days', icon: 'ri-group-line' },
      { label: 'Coverage', value: '2 Photographers • 1 Cinematographer • Drone', icon: 'ri-camera-lens-line' },
      { label: 'Photography Style', value: 'Candid celebration + traditional rituals', icon: 'ri-heart-3-line' },
    ],
    paragraphs: [
      'Divya and Suresh chose Karaikudi for a two-day celebration — a traditional muhurtham at home followed by a grand reception at the town\'s oldest kalyana mandapam. With family travelling in from Chennai, Singapore and Dubai, the couple wanted every reunion and every ritual kept exactly as it happened.',
      'We began with the mehendi and the bride\'s home rituals on day one, then returned early for the muhurtham and the homam on day two. Between the two days our team captured the sangeet, the garland exchange and the laughter of cousins who had not met in years.',
      'Because the celebration ran across two venues, we kept one team on the couple and another moving through the guests — so nothing was missed. The final album reads like a two-day festival, warm and full of movement.',
    ],
    timeline: [
      { step: '01', time: '06:30 AM', title: 'Mehendi & Home Rituals', desc: 'The bride\'s mehendi, family blessings and the quiet preparations at home before the celebrations begin.', icon: 'ri-sun-line' },
      { step: '02', time: '08:30 AM', title: 'Muhurtham & Homam', desc: 'The sacred muhurtham and homam inside the family home, photographed with respect for every tradition and detail.', icon: 'ri-fire-line' },
      { step: '03', time: '12:00 PM', title: 'Garland Exchange & Blessings', desc: 'The thaali, the garland exchange and the happy tears of the family gathered around the couple.', icon: 'ri-heart-3-line' },
      { step: '04', time: '06:30 PM', title: 'Reception & Sangeet', desc: 'Stage coverage, guest candids, the sangeet performances and a relaxed couple session to close the day.', icon: 'ri-camera-lens-line' },
    ],
    images: [
      {
        id: 'divya-1',
        image: 'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20with%20mehendi%20and%20gold%20bangles%20during%20a%20Karaikudi%20wedding%20morning%2C%20warm%20light%2C%20candid%20emotional%20photography%2C%20rich%20amber%20tones%2C%20soft%20background&width=900&height=1100&seq=shabi-story-divya-1&orientation=portrait',
        title: 'Mehendi & Bridal Detail',
        place: 'Karaikudi',
      },
      {
        id: 'divya-2',
        image: 'https://readdy.ai/api/search-image?query=Tamil%20bride%20and%20groom%20exchanging%20jasmine%20garlands%20during%20a%20muhurtham%20in%20Karaikudi%2C%20warm%20golden%20light%2C%20candid%20editorial%20wedding%20photography%2C%20rich%20amber%20tones&width=900&height=1100&seq=shabi-story-divya-2&orientation=portrait',
        title: 'Garland Exchange — Muhurtham',
        place: 'Karaikudi',
      },
      {
        id: 'divya-3',
        image: 'https://readdy.ai/api/search-image?query=Joyful%20Tamil%20newlywed%20couple%20laughing%20with%20family%20at%20a%20reception%20stage%20in%20Karaikudi%2C%20warm%20evening%20light%2C%20cinematic%20editorial%20photography%2C%20rich%20amber%20tones&width=900&height=1100&seq=shabi-story-divya-3&orientation=portrait',
        title: 'Reception & Family Joy',
        place: 'Karaikudi',
      },
    ],
    review: {
      quote: 'From the mehendi to the reception, the team was everywhere without ever being in the way. Our two-day celebration felt like a film when we finally watched it back.',
      name: 'Divya & Suresh',
      role: 'Two-Day Celebration — Karaikudi',
    },
  },
  {
    id: 'st3',
    slug: 'priya-vignesh',
    couple: 'Priya & Vignesh',
    type: 'Destination Wedding',
    place: 'Rameswaram',
    date: '9 February 2025',
    coverImage:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20couple%20at%20a%20beach%20destination%20wedding%20in%20Rameswaram%20at%20golden%20hour%2C%20traditional%20attire%2C%20cinematic%20editorial%20wedding%20photography%2C%20warm%20amber%20tones%2C%20wide%20composition&width=1600&height=1000&seq=shabi-story-priya-cover&orientation=landscape',
    excerpt:
      'A destination wedding by the sea in Rameswaram — temple rituals at dawn and a golden-hour beach reception.',
    to: '/wedding-stories/priya-vignesh',
    facts: [
      { label: 'Wedding Date', value: '9 February 2025', icon: 'ri-calendar-line' },
      { label: 'Venue', value: 'Agni Theertham shoreline & Ramanathaswamy Temple, Rameswaram', icon: 'ri-map-pin-2-line' },
      { label: 'Guests', value: '400 guests from across India', icon: 'ri-group-line' },
      { label: 'Coverage', value: '2 Photographers • 1 Cinematographer • Drone', icon: 'ri-camera-lens-line' },
      { label: 'Photography Style', value: 'Destination storytelling + golden-hour cinematic', icon: 'ri-heart-3-line' },
    ],
    paragraphs: [
      'Priya and Vignesh wanted their wedding by the sea. They gathered 400 guests at Rameswaram, with a dawn temple ceremony followed by an evening celebration on the shoreline. The couple asked us to keep the whole day feeling calm, cinematic and true to the coast.',
      'We started before sunrise at the temple for the muhurtham and the sacred bath rituals, then moved to the beach as the light turned gold. A drone tracked the couple along the water while our team stayed close for the candid moments between family and friends.',
      'Balancing a busy temple with a relaxed beach reception is a challenge, so we planned the timeline around the light. The result is a set that moves from intimate ritual to wide, cinematic coastline — a complete destination story.',
    ],
    timeline: [
      { step: '01', time: '05:30 AM', title: 'Dawn Temple Rituals', desc: 'The early muhurtham and sacred bath rituals at Ramanathaswamy Temple, captured in soft first light.', icon: 'ri-sun-line' },
      { step: '02', time: '08:00 AM', title: 'Homam & Blessings', desc: 'The homam, priest blessings and the garland exchange inside the temple corridors.', icon: 'ri-fire-line' },
      { step: '03', time: '05:30 PM', title: 'Golden-Hour Beach Session', desc: 'A cinematic couple session on the shoreline with drone coverage as the sun sets over the sea.', icon: 'ri-camera-lens-line' },
      { step: '04', time: '07:30 PM', title: 'Beachside Reception', desc: 'An open-air reception with guest candids, speeches and a relaxed close to a long, beautiful day.', icon: 'ri-heart-3-line' },
    ],
    images: [
      {
        id: 'priya-1',
        image: 'https://readdy.ai/api/search-image?query=Tamil%20bride%20and%20groom%20in%20traditional%20attire%20during%20a%20dawn%20temple%20ceremony%20in%20Rameswaram%2C%20soft%20morning%20light%2C%20cinematic%20editorial%20wedding%20photography%2C%20warm%20amber%20tones&width=900&height=1100&seq=shabi-story-priya-1&orientation=portrait',
        title: 'Dawn Temple Ceremony',
        place: 'Rameswaram',
      },
      {
        id: 'priya-2',
        image: 'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20couple%20in%20traditional%20attire%20walking%20along%20a%20beach%20at%20golden%20hour%20in%20Rameswaram%2C%20cinematic%20wide%20composition%2C%20warm%20amber%20tones%2C%20editorial%20wedding%20photography&width=900&height=1100&seq=shabi-story-priya-2&orientation=portrait',
        title: 'Golden-Hour Beach Session',
        place: 'Rameswaram',
      },
      {
        id: 'priya-3',
        image: 'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20newlywed%20couple%20celebrating%20with%20family%20at%20a%20beachside%20reception%20in%20Rameswaram%2C%20warm%20evening%20string%20lights%2C%20cinematic%20editorial%20photography%2C%20rich%20amber%20tones&width=900&height=1100&seq=shabi-story-priya-3&orientation=portrait',
        title: 'Beachside Reception',
        place: 'Rameswaram',
      },
    ],
    review: {
      quote: 'We planned a wedding by the sea and they captured it exactly as we dreamed. The drone shots over the water and the temple light are frames we will keep forever.',
      name: 'Priya & Vignesh',
      role: 'Destination Wedding — Rameswaram',
    },
  },
  {
    id: 'st4',
    slug: 'meera-arun',
    couple: 'Meera & Arun',
    type: 'Pre-Wedding & Muhurtham',
    place: 'Madurai',
    date: '3 November 2024',
    coverImage:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20couple%20in%20traditional%20attire%20in%20a%20lush%20green%20garden%20during%20a%20pre%20wedding%20shoot%2C%20warm%20sunset%20light%2C%20cinematic%20editorial%20photography%2C%20rich%20amber%20tones&width=1600&height=1000&seq=shabi-story-meera-cover&orientation=landscape',
    excerpt:
      'A romantic pre-wedding concept shoot in Madurai followed by an intimate family muhurtham the next morning.',
    to: '/wedding-stories/meera-arun',
    facts: [
      { label: 'Wedding Date', value: '3 November 2024', icon: 'ri-calendar-line' },
      { label: 'Venue', value: 'Madurai — garden estate & family home', icon: 'ri-map-pin-2-line' },
      { label: 'Guests', value: 'Intimate gathering of 150 guests', icon: 'ri-group-line' },
      { label: 'Coverage', value: '1 Photographer • 1 Cinematographer', icon: 'ri-camera-lens-line' },
      { label: 'Photography Style', value: 'Concept pre-wedding + candid muhurtham', icon: 'ri-heart-3-line' },
    ],
    paragraphs: [
      'Meera and Arun are both from Madurai and wanted their story told in two parts — a concept pre-wedding shoot in a garden estate, and an intimate muhurtham the following morning with only close family present.',
      'For the pre-wedding, we built the shoot around the couple\'s love for quiet, green spaces. We used natural light, soft movement and a relaxed direction so the frames felt like a film still rather than a posed session.',
      'The next morning we stayed gentle and unobtrusive for the family muhurtham, focusing on the rituals, the elders and the small glances between the couple. Together the two days read as one continuous, tender story.',
    ],
    timeline: [
      { step: '01', time: '04:00 PM', title: 'Pre-Wedding Concept Shoot', desc: 'A relaxed garden session with natural light, styling guidance and cinematic frame direction.', icon: 'ri-leaf-line' },
      { step: '02', time: '06:00 PM', title: 'Golden-Hour Portraits', desc: 'Couple portraits in warm evening light, including a few surprise frames with the family.', icon: 'ri-sun-line' },
      { step: '03', time: '08:00 AM', title: 'Intimate Muhurtham', desc: 'The family muhurtham and homam photographed quietly, keeping every ritual respectful and natural.', icon: 'ri-fire-line' },
      { step: '04', time: '11:00 AM', title: 'Blessings & Family Frames', desc: 'Blessings from the elders, group portraits and the couple\'s first moments as husband and wife.', icon: 'ri-heart-3-line' },
    ],
    images: [
      {
        id: 'meera-1',
        image: 'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20couple%20in%20traditional%20attire%20in%20a%20lush%20green%20garden%20during%20a%20pre%20wedding%20shoot%2C%20warm%20sunset%20light%2C%20cinematic%20editorial%20photography%2C%20soft%20bokeh%20background&width=900&height=1100&seq=shabi-story-meera-1&orientation=portrait',
        title: 'Garden Pre-Wedding Story',
        place: 'Madurai',
      },
      {
        id: 'meera-2',
        image: 'https://readdy.ai/api/search-image?query=Romantic%20South%20Indian%20Tamil%20couple%20portrait%20in%20warm%20golden%20hour%20light%20during%20a%20pre%20wedding%20shoot%2C%20cinematic%20editorial%20photography%2C%20rich%20amber%20tones%2C%20soft%20background&width=900&height=1100&seq=shabi-story-meera-2&orientation=portrait',
        title: 'Golden-Hour Portraits',
        place: 'Madurai',
      },
      {
        id: 'meera-3',
        image: 'https://readdy.ai/api/search-image?query=Intimate%20South%20Indian%20Tamil%20family%20muhurtham%20at%20home%20with%20sacred%20fire%20and%20blessings%2C%20warm%20light%2C%20candid%20editorial%20wedding%20photography%2C%20rich%20amber%20tones&width=900&height=1100&seq=shabi-story-meera-3&orientation=portrait',
        title: 'Intimate Family Muhurtham',
        place: 'Madurai',
      },
    ],
    review: {
      quote: 'They understood exactly the quiet, romantic mood we wanted. The pre-wedding shots feel like a movie and the muhurtham photos made our families emotional.',
      name: 'Meera & Arun',
      role: 'Pre-Wedding & Muhurtham — Madurai',
    },
  },
  {
    id: 'st5',
    slug: 'kavya-vishal',
    couple: 'Kavya & Vishal',
    type: 'Church Wedding & Reception',
    place: 'Trichy',
    date: '18 January 2025',
    coverImage:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20and%20groom%20at%20a%20church%20wedding%20in%20Trichy%20with%20warm%20evening%20light%2C%20elegant%20traditional%20attire%2C%20cinematic%20editorial%20wedding%20photography%2C%20rich%20amber%20and%20gold%20tones&width=1600&height=1000&seq=shabi-story-kavya-cover&orientation=landscape',
    excerpt:
      'An elegant Trichy church ceremony paired with a grand evening reception — two traditions, one beautiful day.',
    to: '/wedding-stories/kavya-vishal',
    facts: [
      { label: 'Wedding Date', value: '18 January 2025', icon: 'ri-calendar-line' },
      { label: 'Venue', value: 'Holy Cross Church & a heritage banquet hall, Trichy', icon: 'ri-map-pin-2-line' },
      { label: 'Guests', value: '700 guests across the day', icon: 'ri-group-line' },
      { label: 'Coverage', value: '2 Photographers • 1 Cinematographer • Drone', icon: 'ri-camera-lens-line' },
      { label: 'Photography Style', value: 'Elegant editorial + candid celebration', icon: 'ri-heart-3-line' },
    ],
    paragraphs: [
      'Kavya and Vishal brought together two traditions in a single day — a church ceremony in the morning and a grand reception at a heritage banquet hall in the evening. The couple wanted the day to feel elegant, warm and full of their people.',
      'At the church we focused on the quiet vows, the light through the stained glass and the emotional first looks with parents. Later, the reception gave us room for stage portraits, guest candids and the couple\'s grand entry.',
      'Mixing an intimate ceremony with a large celebration needs a clear plan, so we split our team between the couple and the guests. The finished set moves gracefully from hushed, reverent frames to the colour and music of the evening.',
    ],
    timeline: [
      { step: '01', time: '08:00 AM', title: 'Bridal & Groom Preparation', desc: 'Getting-ready moments, family photos and the first looks before leaving for the church.', icon: 'ri-sun-line' },
      { step: '02', time: '10:00 AM', title: 'Church Ceremony', desc: 'The vows, the exchange of rings and the emotional blessing, captured with an elegant editorial eye.', icon: 'ri-heart-3-line' },
      { step: '03', time: '04:30 PM', title: 'Couple & Family Portraits', desc: 'A relaxed portrait session in warm afternoon light with the couple and their closest family.', icon: 'ri-camera-lens-line' },
      { step: '04', time: '07:00 PM', title: 'Grand Evening Reception', desc: 'The couple\'s entry, stage portraits, speeches and candid frames of 700 celebrating guests.', icon: 'ri-group-line' },
    ],
    images: [
      {
        id: 'kavya-1',
        image: 'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20in%20elegant%20wedding%20attire%20getting%20ready%20with%20family%20before%20a%20church%20ceremony%20in%20Trichy%2C%20warm%20light%2C%20candid%20editorial%20photography%2C%20rich%20amber%20tones&width=900&height=1100&seq=shabi-story-kavya-1&orientation=portrait',
        title: 'Bridal Preparation',
        place: 'Trichy',
      },
      {
        id: 'kavya-2',
        image: 'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20and%20groom%20exchanging%20rings%20during%20a%20church%20wedding%20ceremony%20in%20Trichy%2C%20soft%20window%20light%2C%20elegant%20editorial%20wedding%20photography%2C%20warm%20tones&width=900&height=1100&seq=shabi-story-kavya-2&orientation=portrait',
        title: 'Church Ceremony — The Vows',
        place: 'Trichy',
      },
      {
        id: 'kavya-3',
        image: 'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20newlywed%20couple%20on%20a%20grand%20reception%20stage%20in%20Trichy%2C%20warm%20evening%20lighting%2C%20cinematic%20editorial%20wedding%20photography%2C%20rich%20amber%20and%20gold%20tones&width=900&height=1100&seq=shabi-story-kavya-3&orientation=portrait',
        title: 'Grand Evening Reception',
        place: 'Trichy',
      },
    ],
    review: {
      quote: 'Our church ceremony and reception felt like two completely different films, and they captured both beautifully. The portraits of our parents are our most treasured frames.',
      name: 'Kavya & Vishal',
      role: 'Church Wedding & Reception — Trichy',
    },
  },
  {
    id: 'st6',
    slug: 'lakshmi-hari',
    couple: 'Lakshmi & Hari',
    type: 'Traditional Muhurtham',
    place: 'Thanjavur',
    date: '27 May 2024',
    coverImage:
      'https://readdy.ai/api/search-image?query=Traditional%20South%20Indian%20Tamil%20muhurtham%20wedding%20in%20a%20Thanjavur%20temple%20mandapam%2C%20marigold%20decor%2C%20warm%20golden%20lighting%2C%20cinematic%20editorial%20wedding%20photography%2C%20rich%20amber%20tones&width=1600&height=1000&seq=shabi-story-lakshmi-cover&orientation=landscape',
    excerpt:
      'A timeless Thanjavur temple muhurtham rooted in ritual, captured with warmth, patience and detail.',
    to: '/wedding-stories/lakshmi-hari',
    facts: [
      { label: 'Wedding Date', value: '27 May 2024', icon: 'ri-calendar-line' },
      { label: 'Venue', value: 'A 12th-century temple mandapam, Thanjavur', icon: 'ri-map-pin-2-line' },
      { label: 'Guests', value: '300 guests, mostly family', icon: 'ri-group-line' },
      { label: 'Coverage', value: '1 Photographer • 1 Cinematographer', icon: 'ri-camera-lens-line' },
      { label: 'Photography Style', value: 'Classic traditional + candid documentary', icon: 'ri-heart-3-line' },
    ],
    paragraphs: [
      'Lakshmi and Hari married in a 12th-century temple mandapam in Thanjavur, surrounded by stone pillars, oil lamps and generations of family. They wanted the ritual treated with patience and respect above everything else.',
      'We kept our footprint small and our lens long, so the muhurtham could proceed exactly as the elders wished. Between the sacred moments we photographed the homam, the garland exchange and the gentle expressions of the couple\'s parents.',
      'The temple\'s low, warm light made every frame feel timeless. Rather than directing, we waited — and the story that emerged is quiet, dignified and deeply personal.',
    ],
    timeline: [
      { step: '01', time: '06:00 AM', title: 'Temple Preparation', desc: 'The early morning rituals, the bride\'s dressing and the oil lamps being lit inside the mandapam.', icon: 'ri-sun-line' },
      { step: '02', time: '07:30 AM', title: 'Homam & Muhurtham', desc: 'The sacred homam and muhurtham photographed quietly, respecting every step of the tradition.', icon: 'ri-fire-line' },
      { step: '03', time: '09:30 AM', title: 'Thaali & Garland Exchange', desc: 'The thaali, the garland exchange and the blessings of the elders gathered around the couple.', icon: 'ri-heart-3-line' },
      { step: '04', time: '12:00 PM', title: 'Blessings & Family Portraits', desc: 'Organised family groups and the couple\'s first portraits in the temple\'s warm, ancient light.', icon: 'ri-camera-lens-line' },
    ],
    images: [
      {
        id: 'lakshmi-1',
        image: 'https://readdy.ai/api/search-image?query=Traditional%20South%20Indian%20Tamil%20temple%20wedding%20ritual%20with%20oil%20lamps%20and%20flowers%20in%20Thanjavur%2C%20warm%20devotional%20light%2C%20cinematic%20editorial%20photography%2C%20rich%20amber%20tones&width=900&height=1100&seq=shabi-story-lakshmi-1&orientation=portrait',
        title: 'Temple Rituals & Lamps',
        place: 'Thanjavur',
      },
      {
        id: 'lakshmi-2',
        image: 'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20and%20groom%20during%20a%20traditional%20muhurtham%20inside%20a%20stone%20temple%20mandapam%20in%20Thanjavur%2C%20warm%20golden%20light%2C%20cinematic%20editorial%20wedding%20photography&width=900&height=1100&seq=shabi-story-lakshmi-2&orientation=portrait',
        title: 'Muhurtham In The Mandapam',
        place: 'Thanjavur',
      },
      {
        id: 'lakshmi-3',
        image: 'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20newlywed%20couple%20seeking%20blessings%20from%20elders%20during%20a%20traditional%20temple%20wedding%20in%20Thanjavur%2C%20warm%20light%2C%20candid%20editorial%20photography&width=900&height=1100&seq=shabi-story-lakshmi-3&orientation=portrait',
        title: 'Blessings From Family',
        place: 'Thanjavur',
      },
    ],
    review: {
      quote: 'They respected our traditions completely and never once interrupted the ceremony. When we saw the album, it felt like the temple itself was part of the photographs.',
      name: 'Lakshmi & Hari',
      role: 'Traditional Muhurtham — Thanjavur',
    },
  },
]